import { render } from "./AposColorEditableInput.vue?vue&type=template&id=7a7d86ee"
import script from "./AposColorEditableInput.vue?vue&type=script&lang=js"
export * from "./AposColorEditableInput.vue?vue&type=script&lang=js"

import "./AposColorEditableInput.vue?vue&type=style&index=0&id=7a7d86ee&lang=css"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"color-field/ui/apos/lib/AposColorEditableInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a7d86ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a7d86ee', __exports__)) {
    api.reload('7a7d86ee', __exports__)
  }
  
  module.hot.accept("./AposColorEditableInput.vue?vue&type=template&id=7a7d86ee", () => {
    api.rerender('7a7d86ee', render)
  })

}


export default __exports__